import axios from 'axios';

export const loadForms = () => {
  document.querySelectorAll('.form--js').forEach((div) => {
    new Form(div);
  });
};

class Form {
  constructor(div) {
    this.elements = {};
    this.elements.form = div;
    //this.elements.fields = div.querySelectorAll([]);
    this.elements.form.addEventListener('submit', this.submit);
  }

  submit = async (e) => {
    e.preventDefault();
    const form = this.elements.form;
    if (!form.checkValidity()) return;

    const params = {};
    Array.from(form.elements).forEach((e) => {
      if (typeof e.value === undefined || e.value === '') return;
      params[e.name] = e.value;
    });

    const res = await axios.post(form.action, params);

    form.reset();
    form.querySelector('.form__success').classList.add('form__success--show');
  };
}
